/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ org: NonNullable<unknown> }} Onboarding_Org_JoiningInputs */



/**
* | output |
* | --- |
* | "You've been invited to join **{org}**. Your admins have already set things up, so you can start working right away." |
*
* @param {Onboarding_Org_JoiningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_org_joining = /** @type {((inputs: Onboarding_Org_JoiningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Org_JoiningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du wurdest eingeladen, **${i?.org}** beizutreten. Deine Admins haben alles vorbereitet, du kannst also direkt loslegen.`)
	return /** @type {LocalizedString} */ (`You've been invited to join **${i?.org}**. Your admins have already set things up, so you can start working right away.`)
});